import { type FC } from 'react';

import { NextTask } from '../NextTask/NextTask';
import PageNextBuild from '../PageNextBuild/PageNextBuild';

const ExtraNavigation: FC = () => {
  return (
    <div className="flex gap-[5px] mx-4">
      <PageNextBuild />
      <NextTask />
    </div>
  );
};

export { ExtraNavigation };
